import { useAuth } from "@contexts/auth";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { ScrollArea, Title } from "@mantine/core";
import { useNetwork } from "@mantine/hooks";

import { StyledWithDashboardNavbar } from "@layouts/WithDashboardNavbar/WithDashboardNavbar.styled";
import { StyledWrapper } from "@layouts/WithPatientNavbar/WithPatientNavbar.styled";

import { NetworkNotification } from "@components/NetworkNotification";

import { getAccountManagementNavLinks } from "@data/accountManagementNavLinks";


interface WithAccountManagementNavbarProps {
  children: React.ReactNode;
}

export const WithAccountManagementNavbar = ({
  children,
}: WithAccountManagementNavbarProps) => {
  const { t } = useTranslation();
  const { canAccessPath } = useAuth();
  const { online } = useNetwork();

  return (
    <>
      <NetworkNotification />
      <StyledWithDashboardNavbar
        className={`${!online ? "show-notification" : "hide-notification"}`}>
        <div className="upper-nav">
          <Title order={2} fz={22} fw={500}>
            {t("accounts")}
          </Title>
        </div>

        <ScrollArea>
          <ul className="nav-links">
            {getAccountManagementNavLinks().filter(item => canAccessPath(`/account-management/${item.link}`)).map(item => (
              <li className="nav-links-item" key={item.link}>
                <NavLink to={`/account-management/${item.link}`}>
                  {item.title}
                </NavLink>
              </li>
            ))}
          </ul>
        </ScrollArea>
      </StyledWithDashboardNavbar>

      <StyledWrapper
        className={`${!online ? "show-notification" : "hide-notification"}`}>
        {children}
      </StyledWrapper>
    </>
  );
};
